<template>
	<div class="mail-page-wrapper">
		<app-layout>
			<template v-slot:header>
				<Header
                    :title="$t('messages')"
                    :isFilter="false">
				</Header>
			</template>
			<template v-slot:header-mobile>
				<HeaderMobile
                    :title="$t('messages')"
                    :isFilter="false">
				</HeaderMobile>
			</template>
            <div class="row">
                <div class="col-md-12 col-lg-3 col-xl-3 col-xxl-3 mb-3 mb-lg-0">
                    <message-navi
                        :currentBox="tabIndex"
                        @newMessage="newMessageShow"
                        @changeBox="changeTabBox"
                        @getDetailId="showMessageDetail"></message-navi>
                </div>
                <div class="col-md-12 col-lg-9 col-xl-9 col-xxl-9">
                    <message-detail
                        v-show="msgId"
                        :msgId="msgId"
                        @goBack="goToTable"
                    ></message-detail>
                    <message-table
                        v-show="!msgId"
                        :currentBox="tabIndex"
                        @getDetailId="showMessageDetail"
                    ></message-table>
                </div>
            </div>

            <CommonModal ref="newMessageModal" size="xxl">
                <template v-slot:CommonModalTitle><i class="ri-mail-add-line top-plus-2 mr-2"></i> {{ $t('new_message').toUpper() }}</template>
                <template v-slot:CommonModalContent>
                    <new-message-form
                        v-if="newMessageIf"
                        @closeBox="newMessageClose"></new-message-form>
                </template>
            </CommonModal>
		</app-layout>
	</div>
</template>
<script>
	// Template
	import AppLayout from "@/layouts/AppLayout"
	import Header from "@/layouts/AppLayout/Header"
	import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
    //Pages
    import MessageNavi from "./MessageNavi";
    import NewMessageForm from "./NewMessageForm";
    import MessageDetail from "./MessageDetail";
    import MessageTable from "./MessageTable";
    //Components
    import CommonModal from "@/components/elements/CommonModal";



	export default {
		components: {
			AppLayout,
			Header,
			HeaderMobile,

            MessageNavi,
            NewMessageForm,
            MessageDetail,
            MessageTable,
            CommonModal

		},
		metaInfo() {
			return {
				title: this.$t('messages')
			}
		},
		data() {
			return {
                tabIndex: 0,
                newMessageIf: false,
                msgId: null
			}
		},
        watch: {
            tabIndex: {
                handler(value){
                    this.msgId = null
                    if(value == 2){
                        this.tabIndex = 0
                    }
                }
            }
        },
		created() {

		},
		methods: {
            newMessageShow() {
                this.newMessageIf = true
                this.$refs.newMessageModal.$refs.commonModal.show()
            },

            newMessageClose() {
                this.newMessageIf = false
                this.tabIndex = 1
                this.$refs.newMessageModal.$refs.commonModal.hide()
            },

            showMessageDetail(id){
                this.msgId = typeof id == 'object' ? id.value : id
            },

            goToTable(){
                this.msgId = null
            },

            changeTabBox(idx) {
                this.tabIndex = idx;
                this.msgId = null;
            }
		}
	}
</script>

